import styled from 'styled-components'
import { palette } from '../../style/globalColor'

export const DetailWrapper = styled.div`
  padding: 20px 11px 23px;
  border-bottom: 1px solid ${palette.lightGray};
`